export enum Plans {
  FREE = 'free',
  PREMIUM = 'premium',
}
